import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import NewTabIcon from "assets/icons/new_tab.svg?react";
import ReactDOM from "react-dom";
import CaseView from "components/CaseView";
import Button from "components/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ShowCaseModal: FC<Props> = ({ previewCase, toggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToCase = () => {
    navigate(`/cases/${previewCase.Id}/chat`);
  };

  const handleNewTab = () => {
    window.open(
      `${
        import.meta.env.VITE_APP_SITE ?? "https://alfa.pocztaprawnicza.pl"
      }/cases/${previewCase.Id}/chat?fullscreen=1`
    );
    toggle();
  };

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{t("cases.case")}</div>
          <div className={styles.titleButtons}>
            <NewTabIcon className={styles.btn} onClick={handleNewTab} />
            <CloseIcon className={styles.btn} onClick={toggle} />
          </div>
        </div>
        <div className={styles.content}>
          <CaseView
            hideOptions={true}
            forceMenu={true}
            caseIdFromProps={previewCase.Id}
            showCase={true}
            statuses={[]}
            tags={[]}
          />
        </div>
        <div className={styles.footer}>
          <Button
            text={t("cases.goToCase")}
            onClick={handleNavigateToCase}
          ></Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ShowCaseModal;
